import React from "react";

import { ColumnDescription } from "react-bootstrap-table-next";

//Common
import { DataGrid } from "../../../common/VFX-UI";

import { CampaignPledgeProps } from "../../../../types/campaignPledge";
import { getFormattedDate } from "../../../../utility/lib/date";
import { IsDesktop, IsMobile } from "../../../../utility/lib/breakpoints";

import CampaignCard from "./CampaignCard";
import { getActionConfig } from "./utility";
import { ActivePastCampaignDto } from "../../../../app/model/api/types/dto";
import CampaignActionButton from "./CampaignActionButton";

const Campaigns: React.FC<CampaignPledgeProps> = (props) => {
  const { data } = props;

  var columns: ColumnDescription[] = [
    {
      dataField: "id",
      text: "ID",
      hidden: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "startDate",
      text: "Campaign Duration",
      sort: true,
      formatter: (cell: Date, row: ActivePastCampaignDto) =>
        `${getFormattedDate(cell.toString())} - ${getFormattedDate(
          row.endDate ? row.endDate.toString() : ""
        )}`,
      },
      {
          dataField: "code",
          text: "Code",
          sort: false,
      },
    {
      dataField: "id",
      text: "",
      sort: true,
      formatter: (cell: string, row: any) => {
        const config = getActionConfig(row, props.activeCampaigns);
        return config && config.show ? (
          <CampaignActionButton label={config.label} campaignId={row.id} />
        ) : null;
      },
    },
  ];

  return (
    <>
      {IsDesktop() && (
        <DataGrid
          columns={columns}
          data={data}
          noDataMessage={
            props.activeCampaigns
              ? "No Active Campaigns"
              : "No Past Campaigns"
          }
          keyField="id"
        />
      )}

      {IsMobile() && (
        <div className="container mt-4">
          <div className="row">
            {data?.map((campaign) => (
              <CampaignCard
                key={campaign.id}
                campaign={campaign}
                activeCampaigns={props.activeCampaigns}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Campaigns;
